import dispatcher from "./dispatcher";
import actionTypes from "./constants";
import axios from "axios";

export async function getPublishers() {
  const apiData = await axios.get(
    process.env.REACT_APP_API_URL + "publisher/list/all",
    {
      data: {},
      headers: {
        "Content-Type": "application/json"
      }
    }
  );

  dispatcher.dispatch({
    actionTypes: actionTypes.GET_PUBLISHER_DATA,
    posts: apiData.data
  });
}
